import { useApi } from "@utils/useApi";
import { EcommerceShoppingCartClient, ShoppingCartDto } from "@lib/ShiOneClient";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import { SHOPPING_CART_QUERY_KEY } from "@features/unified-user-header-feature/utils/HeaderQueryKeys";


export default function useGetShoppingCart(): UseQueryResult<ShoppingCartDto[] | undefined> {
  const api = useApi(EcommerceShoppingCartClient);
  const { hasPermission } = useClaims();
  const canViewShoppingCart = hasPermission(ShiOnePermission.shoppingCartView);


  const fetch = async () => {
    return await api.getShoppingCartItems();
  };

  return useQuery({
    queryKey: [SHOPPING_CART_QUERY_KEY],
    queryFn: fetch,
    refetchOnWindowFocus: true,
    enabled: canViewShoppingCart,
  });
}